import React from "react";
import type { Performer } from "@shared/schema";

interface ReplacementInfoProps {
  mode: "replacing" | "replace-with";
  performer?: Performer | null;
  name?: string | null;
  instruments?: string[] | null;
  className?: string;
}

export function ReplacementInfo({ 
  mode, 
  performer,
  name,
  instruments,
  className = ""
}: ReplacementInfoProps) {
  // Use either performer object or individual props
  const displayName = performer?.name || name;
  const displayInstruments = performer?.currentInstruments || instruments;
  
  if (!displayName) return null;
  
  const label = mode === "replacing" ? "Replacing" : "Replace with";
  
  return (
    <div className={`flex items-center gap-2 bg-orange-100/40 backdrop-blur-sm px-3 py-2 rounded-lg border border-orange-200/50 shadow-sm ${className}`}>
      <span className="text-sm font-medium text-orange-700/90 drop-shadow-sm">
        {label}:
      </span>
      <span className="text-sm font-bold text-orange-800/90 drop-shadow-sm">
        {displayName}
      </span>
      {displayInstruments && displayInstruments.length > 0 && (
        <span className="text-xs text-orange-600/80 drop-shadow-sm">
          ({displayInstruments.join(", ")})
        </span>
      )}
    </div>
  );
}